import { render, staticRenderFns } from "./wl-contextmenu.vue?vue&type=template&id=3c88b214&"
import script from "./wl-contextmenu.vue?vue&type=script&lang=js&"
export * from "./wl-contextmenu.vue?vue&type=script&lang=js&"
import style0 from "./wl-contextmenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports